"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSvg = require("react-svg");
var _clsx = _interopRequireDefault(require("clsx"));
var _utils = require("@material-ui/core/utils");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const styles = _ref => {
  let {
    color,
    size,
    theme
  } = _ref;
  const createStyle = color => {
    return {
      "& svg path": {
        fill: color
      }
    };
  };
  const createStrokeStyle = color => {
    return {
      "& svg": {
        stroke: color
      }
    };
  };
  return {
    root: {
      lineHeight: 0,
      "& svg": {
        height: "100%",
        width: size
      }
    },
    colorInitial: {},
    colorInherit: createStyle("currentColor"),
    colorAction: createStyle(theme.palette.action.active),
    colorDisabled: createStyle(theme.palette.action.disabled),
    colorPrimary: createStyle(theme.palette.primary.main),
    colorSecondary: createStyle(theme.palette.secondary.main),
    colorInfo: createStyle(theme.palette.info.main),
    colorSuccess: createStyle(theme.palette.success.main),
    colorWarning: createStyle(theme.palette.warning.main),
    colorError: createStyle(theme.palette.error.main),
    colorPaper: createStyle(theme.palette.background.paper),
    colorStrokeInitial: {},
    colorStrokeInherit: createStrokeStyle("currentColor"),
    colorStrokeAction: createStrokeStyle(theme.palette.action.active),
    colorStrokeDisabled: createStrokeStyle(theme.palette.action.disabled),
    colorStrokePrimary: createStrokeStyle(theme.palette.primary.main),
    colorStrokeSecondary: createStrokeStyle(theme.palette.secondary.main),
    colorStrokeInfo: createStrokeStyle(theme.palette.info.main),
    colorStrokeSuccess: createStrokeStyle(theme.palette.success.main),
    colorStrokeWarning: createStrokeStyle(theme.palette.warning.main),
    colorStrokeError: createStrokeStyle(theme.palette.error.main),
    colorStrokePaper: createStrokeStyle(theme.palette.background.paper)
  };
};
const withStylesProps = styles => ParentComponent => props => {
  const Component = (0, _styles.withStyles)(theme => styles({
    ...props,
    theme
  }))(ParentComponent);
  return /*#__PURE__*/_react.default.createElement(Component, props);
};
var _default = exports.default = withStylesProps(styles)(_ref2 => {
  let {
    fallback,
    className,
    classes,
    color = "inherit",
    size = 24,
    src,
    stroke = false,
    wrapper = "div",
    ...other
  } = _ref2;
  const {
    PUBLIC_URL
  } = process.env;
  return /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, _extends({
    className: (0, _clsx.default)(classes.root, stroke ? {
      [classes["colorStroke".concat((0, _utils.capitalize)(color))]]: color
    } : {
      [classes["color".concat((0, _utils.capitalize)(color))]]: color
    }, className),
    fallback: fallback ? () => /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, _extends({
      className: (0, _clsx.default)(classes.root, stroke ? {
        [classes["colorStroke".concat((0, _utils.capitalize)(color))]]: color
      } : {
        [classes["color".concat((0, _utils.capitalize)(color))]]: color
      }, className),
      src: PUBLIC_URL + fallback,
      wrapper: wrapper
    }, other)) : () => {
      console.error("ReactSVGIcon: file \"".concat(src, "\" not found"));
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    },
    src: PUBLIC_URL + src,
    wrapper: wrapper
  }, other));
});